import { Card, Col, Row } from "antd";
import { GeneralInfo } from "./GeneralInfo";
import { NextPayment } from "./NextPayment";
import { Disclaimer } from "./Disclaimer";
import { AccountDetails } from "./AccountDatails";
import { AdditionalLinks } from "./AdditionalLinks";
import { useMemo } from "react";
import dayjs from "../../../../../../configs/dayjs";
import { PrintCouponBanner } from "./PrintCouponBanner";
import { ShortageBanner } from "./ShortageBanner";
import "./styles.scss";

type DetailsProps = {
  accountData: any;
};

export const Details = ({ accountData }: DetailsProps) => {
  const showCouponBanner: boolean = useMemo(() => {
    const now = dayjs();
    return now.year() < 2027 && now.month() < 3;
  }, []);

  return (
    <div className="tab-content">
      <div className="mb-4 h-100">
        <>
          {accountData.generalInformation.showImpoundShortage && (
            <ShortageBanner />
          )}
          <Row className="cards-row w-100 justify-center pt-4">
            <Col className="main-info-card">
              <Card className="main-info-content general">
                <GeneralInfo data={accountData.generalInformation} />
              </Card>
            </Col>
            <Col className="secondary-info-card">
              <Card className="secondary-info-content next-payment">
                <NextPayment
                  data={accountData.nextPayment}
                  generalInfo={accountData.generalInformation}
                />
              </Card>
            </Col>
          </Row>
          <Row className="cards-row w-100 justify-center mt-4 second-row">
            <Col className="main-info-card">
              <Card className="main-info-content">
                <AccountDetails data={accountData.generalInformation} />
              </Card>
            </Col>
            <Col className="secondary-info-card">
              <Card className="secondary-info-content additional-links">
                <AdditionalLinks
                  accountGeneralData={accountData.generalInformation}
                />
              </Card>
            </Col>
          </Row>
          {showCouponBanner && (
            <Row className="justify-center my-4">
              <Col className="full-width-content">
                <PrintCouponBanner />
              </Col>
            </Row>
          )}
          <Row className="justify-center my-4 pb-4">
            <Col className="full-width-content">
              <Disclaimer />
            </Col>
          </Row>
        </>
      </div>
    </div>
  );
};
